// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ===== Selected Branch Header — خطوط ومسافات موحّدة ===== */
.branch-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  direction: rtl; /* Force AR to right, EN to left */
  max-width: 100%;
  margin: 0.2rem 0.25rem;
  padding: 8px 8px;
  border: 1px solid #36a3f7;
  border-radius: 12px;
  background: #fff;
  font-family: "Cairo", sans-serif;
  font-size: 14px; /* البقية 14px */
  box-sizing: border-box;
}

.branch-header__side {
  width: 40%;
  display: flex;
  flex-direction: column;
}

/* AR items */
.branch-header__side--ar {
  text-align: right;
  direction: rtl;
}

/* EN items */
.branch-header__side--en {
  text-align: left;
  direction: ltr;
}

.branch-header__title {
  margin: 0 0 0.25rem 0;
  font-size: 18px; /* اسم الشركة */
  font-weight: 700;
  line-height: 1.3;
  color: #575962;
  word-wrap: break-word;
  min-height: 2.6em; /* Force alignment for up to 2 lines */
}

.branch-header__branch-name {
  margin: 0 0 0.25rem 0;
  font-size: 16px; /* اسم الفرع */
  font-weight: 600;
  line-height: 1.3;
  color: #6c757d;
  min-height: 1.3em;
}

.branch-header__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.branch-header__item {
  margin: 0;
  font-size: 14px; /* البقية: هاتف، إيميل، العنوان */
  font-weight: 500;
  line-height: 1.35;
  color: #575962;
  min-height: 1.35em;
}

.branch-header__label {
  font-weight: 600;
  color: #3f4254;
}

.branch-header__logo {
  width: 20%;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0.5rem 0 0.2rem;
}

/* تناسب الصورة مع حجم الشعار الأكبر دون تغيير توازن المخطط */
.branch-header__logo-img {
  height: 5.75rem;
  width: auto;
  max-width: 100%;
  max-height: 6rem;
  object-fit: contain;
  object-position: center;
  border-radius: 8px;
}

@media (max-width: 576px) {
  .branch-header {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  .branch-header__side {
    width: 100%;
  }
  .branch-header__logo {
    width: 100%;
    order: -1;
  }
}
/* Print: preserve layout — force 3 columns (Arabic | logo | English) */
@media print {
  .branch-header {
    display: grid !important;
    grid-template-columns: 1fr auto 1fr !important;
    gap: 0 0.9rem !important;
    margin: 0.25rem 0;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .branch-header__logo {
    order: unset !important;
  }
  .branch-header__title {
    font-size: 18px;
  }
  .branch-header__branch-name {
    font-size: 16px;
  }
  .branch-header__item {
    font-size: 14px;
  }
  .branch-header__logo-img {
    height: 5.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/selected-branch-header/selected-branch-header.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6DAAA;AAEA;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,cAAA,EAAA,kCAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA,EAAA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA,aAAA;AACA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA,aAAA;AACA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA,EAAA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA,EAAA,sCAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA,EAAA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA,EAAA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;AACF;;AAEA,6DAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EACF;EACA;IACE,WAAA;EACF;EACA;IACE,WAAA;IACA,SAAA;EACF;AACF;AAEA,uEAAA;AACA;EACE;IACE,wBAAA;IACA,8CAAA;IACA,wBAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EAAF;EAGA;IACE,uBAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,eAAA;EADF;AACF","sourcesContent":["/* ===== Selected Branch Header — خطوط ومسافات موحّدة ===== */\n\n.branch-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  direction: rtl; /* Force AR to right, EN to left */\n  max-width: 100%;\n  margin: 0.2rem 0.25rem;\n  padding: 8px 8px;\n  border: 1px solid #36a3f7;\n  border-radius: 12px;\n  background: #fff;\n  font-family: 'Cairo', sans-serif;\n  font-size: 14px; /* البقية 14px */\n  box-sizing: border-box;\n}\n\n.branch-header__side {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* AR items */\n.branch-header__side--ar {\n  text-align: right;\n  direction: rtl;\n}\n\n/* EN items */\n.branch-header__side--en {\n  text-align: left;\n  direction: ltr;\n}\n\n.branch-header__title {\n  margin: 0 0 0.25rem 0;\n  font-size: 18px; /* اسم الشركة */\n  font-weight: 700;\n  line-height: 1.3;\n  color: #575962;\n  word-wrap: break-word;\n  min-height: 2.6em; /* Force alignment for up to 2 lines */\n}\n\n.branch-header__branch-name {\n  margin: 0 0 0.25rem 0;\n  font-size: 16px; /* اسم الفرع */\n  font-weight: 600;\n  line-height: 1.3;\n  color: #6c757d;\n  min-height: 1.3em;\n}\n\n.branch-header__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.branch-header__item {\n  margin: 0;\n  font-size: 14px; /* البقية: هاتف، إيميل، العنوان */\n  font-weight: 500;\n  line-height: 1.35;\n  color: #575962;\n  min-height: 1.35em;\n}\n\n.branch-header__label {\n  font-weight: 600;\n  color: #3f4254;\n}\n\n.branch-header__logo {\n  width: 20%;\n  position: relative;\n  z-index: 10;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0.5rem 0 0.2rem;\n}\n\n/* تناسب الصورة مع حجم الشعار الأكبر دون تغيير توازن المخطط */\n.branch-header__logo-img {\n  height: 5.75rem;\n  width: auto;\n  max-width: 100%;\n  max-height: 6rem;\n  object-fit: contain;\n  object-position: center;\n  border-radius: 8px;\n}\n\n@media (max-width: 576px) {\n  .branch-header {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n  .branch-header__side {\n    width: 100%;\n  }\n  .branch-header__logo {\n    width: 100%;\n    order: -1;\n  }\n}\n\n/* Print: preserve layout — force 3 columns (Arabic | logo | English) */\n@media print {\n  .branch-header {\n    display: grid !important;\n    grid-template-columns: 1fr auto 1fr !important;\n    gap: 0 0.9rem !important;\n    margin: 0.25rem 0;\n    padding: 10px 12px;\n    border-radius: 10px;\n  }\n\n  .branch-header__logo {\n    order: unset !important;\n  }\n  .branch-header__title {\n    font-size: 18px;\n  }\n  .branch-header__branch-name {\n    font-size: 16px;\n  }\n  .branch-header__item {\n    font-size: 14px;\n  }\n  .branch-header__logo-img {\n    height: 5.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
